import React from 'react';
import PropTypes from 'prop-types';
import Image from '../base/Image/Image';

const Brand = ({onBrandClick,logoUrl}) => {
    return(
        <div 
            className="brand-div col-xs-10 col-sm-12 col-md-12 col-lg-12"
            onClick={onBrandClick} >
            {/* <Image
                additionalClass="brand"
                imageSrc={logoUrl} /> */}
                <div className="brand"></div>
                
        </div>
    );
};

Brand.propTypes = {
    onBrandClick: PropTypes.func.isRequired,
    logoUrl: PropTypes.string.isRequired
};

export default Brand;


// WEBPACK FOOTER //
// ./src/components/TopMenu/Brand.js